import Request from './request';
import crypto from 'crypto'
import { setJsonStorage } from '../util/storage'
import app from "../main";

export const querywxlogin = (querys) => {
  let params = querys.split("&");
  if (params.length > 0) {
    let par = {};
    for (let p in params) {
      let pp = params[p].split("=");
      par[pp[0]] = pp[1];
    }
    if (par['wxunionid']) {
      wxlogin(par['wxunionid']).then(res => {
        loged(res.data);
      });
    } else if (par['wxopenid'] && par['wxcode']) {
      wxphonelogin(par['wxopenid'], par['wxcode']).then(res => {
        loged(res.data);
      });
    }
  }
};

export const loged = (user) => {
  setJsonStorage('rfq_user',user);
  getUserPrivileges().then(res => {
    if(res && res.status === 0){
      setJsonStorage('rfq_privileges',res.data);
      //微信小程序分享跳转
      if(app.$browserType===1){
        app.$wx.miniProgram.redirectTo({url: '/pages/index/main?shareRedirect=1'})
      }
    }
  });
};

export const getDomain = () => {
  return Request.domain();
};

export const md5 = (str) => {
  return crypto.createHash('md5').update(str).digest('hex');
};

export const sha512 = (str) => {
  return crypto.createHash('sha512').update(str).digest('hex');
};

export const wxlogin = (wxunionid) => {
  return Request.post('/wxlogin', {unionid:wxunionid});
};

export const wxphonelogin = (wxopenid,wxcode) => {
  return Request.post('/wxphonelogin', {openid:wxopenid,code:wxcode});
};

export const wxPasswordChange = (npass,rpass) => {
  return Request.post('/user/password/wxmp/change', {npass:sha512(npass),rpass:sha512(rpass)});
};

export const websendphonevalid = (phone) => {
  return Request.post('/phone/regist/verification',{phone:phone});
};

export const webphoneregist = (params) => {
  let data = JSON.parse(JSON.stringify(params));
  data['password'] = sha512(data['password']);
  data['repassword'] = sha512(data['repassword']);
  return Request.post('/phone/regist/submit',data);
};

export const weblogin = (phone,password) => {
  return Request.post('/login/phone', { phone:phone,password:sha512(password) });
};

export const weblogout = () => {
  return Request.post('/logout', {});
};

export const refreshLogin = () => {
  return Request.get('/login/fresh',{});
};

export const getUserPrivileges = () => {
  return Request.get('/privileges', {});
};

export const getUserRecommendCount = () => {
  return Request.get('/user/recommend/count', {});
};

export const getUserRecommendInfo = () => {
  return Request.get('/user/recommend/info', {});
};

export const getUserRecommendUsers = () => {
  return Request.get('/user/recommend/users', {});
};

export const bindUserRecommend = (code) => {
  return Request.get('/user/recommend?code='+code, {});
};

export const getTyphoonActive = () => {
  return Request.get('/datacenter/standard/enviroment/weather/typhoon?type=2',{});
};

export const searchShips = (keyword) => {
  return Request.get('/datacenter/standard/ship/search',{keyword:keyword});
};

export const searchShipsParams = (params) => {
  return Request.get('/datacenter/standard/ship/search',params);
};

export const getShipBase = (mmsi) => {
  return Request.get('/datacenter/standard/ship/info/all',{mmsi:mmsi});
};

export const getShipImgs = (params) => {
  return Request.get('/datacenter/standard/ship/img/all',params);
};

export const getShipModeltype = (mmsi) => {
  return Request.get('/datacenter/standard/ship/info/modeltype',{mmsi:mmsi});
};

export const getNewsList = (page,size) => {
  return Request.get('/datacenter/sapi/news/list',{page:page,size:size});
};

export const getNewsDetail = (id) => {
  return Request.get('/datacenter/sapi/news/info',{id:id});
};

export const getIncidentsTags = () => {
  return Request.get('/datacenter/standard/incident/tags',{});
};

export const getIncidentsOrgs = () => {
  return Request.get('/datacenter/standard/incident/orgs',{});
};

export const getIncidentsList = (params) => {
  return Request.get('/datacenter/standard/incidentInfo',params);
};

export const getIncidentDetail = (id) => {
  return Request.get('/datacenter/standard/incidentInfo/detail?id='+id,{});
};

export const getVesselSum = (mmsi,start,end) => {
  return Request.get('/datacenter/standard/ship/speed/sum/mmsi',{mmsi:mmsi,start:start,end:end,interval:1});
};

export const getCreditFinalV3 = (params) => {
  return Request.get('/datacenter/standard/credit/final_v3',params);
};

export const getClubByImo = (imo) => {
  return Request.get('/datacenter/sapi/club',{keyword:imo});
};

export const getBuilderByBuilderCleanId = (builder_clean_id) => {
  return Request.get('/datacenter/standard/builder/info',{builder_clean_id:builder_clean_id});
};

export const getShipRisk = (mmsi) => {
  return Request.get('/datacenter/standard/riskv4/search',{mmsi:mmsi,type:'rdbso'});
};

export const getShipSpeedRisk = (mmsi) => {
  return Request.get('/datacenter/standard/ship/speed/risk/v4',{mmsi:mmsi});
};

export const getShipRiskRoute = (mmsi) => {
  return Request.get('/datacenter/standard/riskv4/ship/route',{mmsi:mmsi});
};

export const getShipImoIncident = (imo,mmsi) => {
  return Request.get('/datacenter/sapi/imoIncident/search',{imo:imo,mmsi:mmsi});
};

export const getShipPsc = (imo,mmsi) => {
  return Request.get('/datacenter/standard/al/psc/search',{imo:imo ? imo : '',mmsi:mmsi ? mmsi : ''});
};

export const checkValidUrl = (uri,params) => {
  return Request.post('/user/access/valid?uri='+uri,params);
};


export const getShipScore = (mmsi) => {
  return Request.get('/datacenter/standard/riskv4/ship/score?mmsi='+mmsi,{});
};

export const searchAccessGoods = (uri) => {
  return Request.get('/user/access/search?uri='+uri,{});
};

export const createAccessOrder = (goods_id) => {
  return Request.get('/user/goods/access/order/create?access_goods_id='+goods_id,{});
};

export const wechatPrepay = (order_id,open_id) => {
  return Request.get('/pay/wechat/prepay',{order_id:order_id,open_id:open_id});
};

export const getUserGoodsRoleAll = () => {
  return Request.get('/user/goods/role/all',{});
};

export const createRoleOrder = (goods_id) => {
  return Request.get('/user/goods/role/order/create?role_goods_id='+goods_id,{});
};

export const getOrderSum = () => {
  return Request.get('/user/goods/access/order/sum',{});
};

export const getShipMissionCount = () => {
  return Request.get('/ship/mission/count',{});
};

export const getUserAccesOrderLog = (page,size) => {
  return Request.get('/user/goods/access/order/log',{uri:'/datacenter/standard/riskv4/ship/score',page:page,size:size});
};

export const getRoleOrderLog = (page,size) => {
  return Request.get('/user/goods/role/order/list',{page:page,size:size});
};

export const getAccessOrderLog = (page,size) => {
  return Request.get('/user/goods/access/order/list',{page:page,size:size});
};

export const getWebIndexCounts = () => {
  return Request.get('/datacenter/standard/ship/index/count',{});
};

export const getShipEvaluationTrading = (params) => {
  return Request.get('/datacenter/django/evaluation_trading',params);
};

export const getHsjvioTypes = () => {
  return Request.get('/datacenter/standard/hsjvio/types',{});
};

export const searchHsjvio = (params) => {
  return Request.get('/datacenter/standard/hsjvio/list',params);
};

export const getHsjvioDetail = (id) => {
  return Request.get('/datacenter/standard/hsjvio/detail',{id:id});
};

export const getWenshuSelectors = (column) => {
  //colomn=province,matchwords,label
  return Request.get('/datacenter/sapi/wenshu/getlist',{column:column?column:'province,matchwords,label'});
};

export const getWenshuAccords = (province) => {
  return Request.get('/datacenter/sapi/wenshu/getlist',{column:'accord',province:province});
};

export const getWenshuMatchwords = (params) => {
  //title/label/begin/end
  return Request.get('/datacenter/sapi/wenshu/matchwords',params);
};

export const getWenshuSearch = (params) => {
  //title/label/accord//begin/end/matchwords/shipnames/plaintiff_defendant/lawyer/firm/page/size
  return Request.get('/datacenter/sapi/wenshu/search',params);
};

export const getWenshuInfo = (rowkey) => {
  return Request.get('/datacenter/sapi/wenshu/info',{rowkey:rowkey});
};

export const getRiskFilepath = (mmsi,type) => {
  return Request.get('/datacenter/standard/riskv4/report/filepath',{mmsi:mmsi,type:type});
};

export const reportSearch = (params) => {
  return Request.get('/insurance/report/search',params);
};

export const reportGet = (rid) => {
  return Request.get('/insurance/report/get',{rid:rid});
};

export const reportAdd = (params) => {
  return Request.post('/insurance/report/add',params);
};

export const insuranceOrderSearch = (params) => {
  return Request.get('/insurance/order/search',params);
};

export const insuranceOrderGet = (oid) => {
  return Request.get('/datacenter/standard/insurance/order/get',{oid:oid});
};

export const insuranceOrderQuoteGet = (oid) => {
  return Request.get('/datacenter/standard/insurance/order/quote/get',{oid:oid});
};

export const insuranceMainTermsAll = () => {
  return Request.get('/datacenter/standard/insurance/main/all',{});
};

export const insuranceAdditionalTermsAll = () => {
  return Request.get('/datacenter/standard/insurance/additional/all',{});
};

export const addInsuranceOrder = (data) => {
  return Request.post('/insurance/order/add',data);
};

export const updateInsuranceOrderQuoteUpdate = (data) => {
  return Request.post('/insurance/order/quote/update',data);
};

export const insuranceOrderQuoteSearch = (params) => {
  return Request.get('/insurance/order/quote/search',params);
};

export const getInsuranceProductsAll = () => {
  return Request.get('/datacenter/standard/insurance/products/all');
};

export const getInsuranceProductsById = (id) => {
  return Request.get('/datacenter/standard/insurance/products/get?id='+id);
};

export const insuranceMainTermsById = (id) => {
  return Request.get('/datacenter/standard/insurance/main/get',{id:id});
};

export const insuranceAdditionalTermsById = (id) => {
  return Request.get('/datacenter/standard/insurance/additional/get',{id:id});
};

export const insuranceSpecialTermsById = (id) => {
  return Request.get('/datacenter/standard/insurance/special/get',{id:id});
};

export const insuranceDeductibleTermsById = (id) => {
  return Request.get('/datacenter/standard/insurance/deductible/get',{id:id});
};




// WEBPACK FOOTER //
// ./src/api/api.js